import { useIntl } from 'react-intl';

export function useMessages() {
  const intl = useIntl();

  const getChannelRecommendationMessages = () => ({
    header: intl.formatMessage({
      defaultMessage: 'Boost your hiring performance',
      description:
        'Org dashboard recommendation card title for improving sourcing spend',
    }),
    description: intl.formatMessage({
      defaultMessage:
        'Current campaign performance may fall short of hiring goal. Post to high-performing channels to reach your goal faster.',
      description:
        'Body copy: suggests adding or funding channels when the goal is at risk',
    }),
  });

  return { getChannelRecommendationMessages };
}
